import { DialogModal } from './DialogModal';
import { useSelector } from 'react-redux';
import { clientHasAnnuityFunding, selectClient } from '..';
import EmptyStateAddButtons, {
  EmptyStateAddOptionDef,
} from './EmptyStateAddButtons';

type SelectFundingSourceModalProps = {
  open: boolean;
  emptyStateAddOptions: EmptyStateAddOptionDef[];
  onClose: () => void;
};

export function SelectFundingSourceModal({
  open,
  emptyStateAddOptions,
  onClose,
}: SelectFundingSourceModalProps) {
  const client = useSelector(selectClient);

  const hasAnnuity = clientHasAnnuityFunding(client);

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title="Funding options"
      subTitle="Select a funding type to get started."
    >
      <EmptyStateAddButtons
        className="mt-6"
        addOptions={emptyStateAddOptions.filter(option => {
          if (option.title.toLocaleLowerCase().includes('annuities')) {
            return !hasAnnuity;
          }
          return true;
        })}
        forModal={true}
      />
    </DialogModal>
  );
}
